export default __webpack_public_path__ + "static/media/touch_ng1.3da4f996.mp3";